import { Collection } from "@tblabs/truffle";
import { JobOfferQuestionEntry } from "./JobOfferQuestionEntry";
import { Recruit } from "./Recruit";
import { IStorable } from "./IStorable";


export class ApplyForm implements IStorable
{
    public Id: string = "";
    public Position: string = "";
    public Answers = new Collection<JobOfferQuestionEntry>();
    public Recruit = new Recruit();
    public ApplyTime: Date = new Date(0); // TODO: remove this field
    public CreatedAt = new Date(0);

    constructor(id: string)
    {
        this.Id = id;
    }
}
